import { render, staticRenderFns } from "./ServiceProviderTypeChip.vue?vue&type=template&id=32b92758&"
import script from "./ServiceProviderTypeChip.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderTypeChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports